import { readSettings } from '../settings'

export const getDummyDataSettings = () => {
  const { dummyData } = readSettings()
  return {
    delaySeconds: dummyData?.delaySeconds || 0,
    logRequests: dummyData?.logRequests || false,
  }
}
